module.exports = "/images/icon-sliderArrowLeft.svg?419cea74367926d44ce7d1f7890363c8";